import { Stack, LinearProgress } from "@mui/material"


const AtplLinearBar = ({ value }) => {
    return (
        <Stack sx={{
            marginTop : {
                xs : '14px',
                sm:2,
                md:3,
                lg:3
            }
             
        }}>
            <LinearProgress
                variant="determinate"
                value={value}
                sx={{
                    height: {
                        xs : "8px",
                        sm:"8px",
                        md:"10px",
                        lg:"14px"
                    },
                    borderRadius: 4,
                    background: `linear-gradient(0deg, rgba(217, 217, 217, 0.25), rgba(217, 217, 217, 0.25)),
                                      linear-gradient(0deg, rgba(217, 217, 217, 0.25), rgba(217, 217, 217, 0.25))
                                      ` + ' !important',
                      boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1),0px 4px 23px rgba(0, 0, 0, 0.04)',

                //     boxShadow: `
                //     0px 8px 19px 0px #0000001A,
                //     0px 34px 34px 0px #00000017,
                //     0px 76px 46px 0px #0000000D,
                //     0px 135px 54px 0px #00000003,
                //     0px 211px 59px 0px #00000000
                //   `,
                    '& .MuiLinearProgress-barColorPrimary': {
                        backgroundColor: "#F15C30",
                        boxShadow: `
                        0px 8px 19px 0px #0000001A,
                        0px 34px 34px 0px #00000017,
                        0px 76px 46px 0px #0000000D,
                        0px 135px 54px 0px #00000003,
                        0px 211px 59px 0px #00000000
                      `,
                    }

                }}
            />
        </Stack>
    )
}

export default AtplLinearBar